import * as React from 'react';
import classnames from 'classnames';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { useProductDetailSlots } from '../../../slots/context.js';
import '@grandvisionhq/forms';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '../../../types/product.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/elements';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/common';
import '../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import { SingleFacetPicker } from '../components/FacetPickerContainers/SingleFacetPicker/SingleFacetPicker.js';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '../../../hooks/use-product-view-history.js';
import { ProductTag } from '../components/ProductTag/ProductTag.js';
import { PriceSectionContainer } from '../components/PriceSection/PriceSectionContainer.js';
import '@grandvisionhq/content';

const AccessoriesEcommContent = ({ className , cta , ctaRef  })=>{
    const { activeVariant: { displayName , sku: activeSku , isExcludedFromCheckout  } ,  } = useProductData();
    const { Slots  } = useProductDetailSlots();
    return /*#__PURE__*/ React.createElement("section", {
        "aria-label": displayName,
        className: classnames('accessories-ecomm-content', className)
    }, /*#__PURE__*/ React.createElement(ProductTag, null), /*#__PURE__*/ React.createElement("div", {
        className: "accessories-ecomm-content__section"
    }, /*#__PURE__*/ React.createElement(PriceSectionContainer, null)), /*#__PURE__*/ React.createElement(SingleFacetPicker, {
        className: "accessories-ecomm-content__section"
    }), Slots.DynamicDeliveryIndicator ? /*#__PURE__*/ React.createElement(Slots.DynamicDeliveryIndicator, {
        isExcludedFromCheckout: isExcludedFromCheckout,
        deliveryItems: [
            {
                sku: activeSku,
                quantity: 1
            }
        ]
    }) : null, /*#__PURE__*/ React.createElement("div", {
        ref: ctaRef
    }, cta), Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null);
};

export { AccessoriesEcommContent };
//# sourceMappingURL=AccessoriesEcommContent.js.map
